export default "__VITE_ASSET__ISxzCu$C__"